import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import {useDispatch, useSelector} from "react-redux";
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { history } from '../../_services/essentials/helpers';
import {breadcrumbsActions} from "../../_services/essentials/store";

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));


export default function NavbarBreadcrumbs() {
  const currentTitle = useSelector(x => x.breadcrumbs?.current_title);
  // const previous_url = useSelector(x => x.breadcrumbs?.previous_url);
  //const current_page_index = useSelector(x => x.breadcrumbs?.current_page_index);

//  const url_list = useSelector(x => x.breadcrumbs.url_list);

 const dispatch = useDispatch();

  // console.log('previous_url: '+JSON.stringify(previous_url));
  // console.log('previous_url.url: '+JSON.stringify(previous_url?.url));
  async function handleBack() {
//alert('previous_url.url: '+previous_url.url);
     const previousURL = await dispatch(breadcrumbsActions.getPreviousURL()).unwrap();
//     console.log('previousURL: '+previousURL.url);
//     history.navigate(previousURL.url, {state: previousURL.state});
//   history.navigate(previous_url.url, {state: previous_url.state});
      history.navigate(previousURL.url, {state: previousURL.state});

    //history.navigate(previous_url.url);
    //alert('previous_url total loads: '+previous_url.total_reloads_in_the_page);
//    let total_reloads_in_the_page = (previous_url && previous_url.total_reloads_in_the_page) ? previous_url.total_reloads_in_the_page : 1;
    //alert('total_reloads_in_the_page: '+total_reloads_in_the_page);

    //history.navigate(total_reloads_in_the_page*-1);  // Good one - Working model   // Good one - Working model
//    history.navigate(total_reloads_in_the_page*-1);  // Good one - Working model   // Good one - Working model


    //history.navigate((total_reloads_in_the_page*-1), {state: history.location?.state});
    // for (var navi=-1; navi>=(total_reloads_in_the_page*-1); navi--) {
    //   history.navigate(navi);
    // }

  }

  return (
      <StyledBreadcrumbs
          // aria-label="breadcrumb"
          // separator={<NavigateNextRoundedIcon fontSize="small" />}
      >
        {/*<Typography variant="body1">Dashboard</Typography>*/}
        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 600, ml: 1, fontSize: '22px' }}>
          {/* <ArrowBackIcon sx={{ color: 'primary.main', mb: .5 }}></ArrowBackIcon> */}

          {(currentTitle) ? (<><ArrowBackIosNewRoundedIcon onClick={() => handleBack()} fontSize='medium' sx={{ color: 'primary.main', mb: 0.5, cursor: 'pointer' }} /> {currentTitle}</>) : (<>  {currentTitle} </>)}
        </Typography>
      </StyledBreadcrumbs>
  );
}
